export type LoadingState = 'loading' | 'error' | 'success' | 'idle'

export const combineLoadingStates = (
  stateX: LoadingState,
  stateY: LoadingState,
): LoadingState => {
  if (stateX === 'loading' || stateY === 'loading') {
    return 'loading'
  }

  if (stateX === 'error' || stateY === 'error') {
    return 'error'
  }

  if (stateX === 'success' && stateY === 'success') {
    return 'success'
  }

  return 'idle'
}
